import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo, useState } from "react";
import {
  createSecurityAuthRoleToUser,
  createSecurityAuthRoleToUserSuccess,
  deleteSecurityAuthRoleToUser,
  deleteSecurityAuthRoleToUserSuccess,
  getSecurityAuthRoleList,
  getSecurityAuthRoleToUserList,
} from "../../../../store/security/action";
import { getStaffList } from "../../../../store/staff/action";
import HandleDateTime from "../../../../Components/Common/HandleDateTime";
import { Col, Input, Label, Row } from "reactstrap";
import AppModal from "../../../../Components/Common/AppModal";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import TableContainer from "../../../../Components/Common/TableContainer";
import Select from "react-select";
import LoadingSpinner from "../../../../Components/Common/Spinner";

const SecurityRoleToUser = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSecurityAuthRoleToUserList());
    dispatch(getSecurityAuthRoleList());
    dispatch(getStaffList());
  }, []);
  const { data, securityAuthRoleListAPI, securityAuthRoleListLoading } =
    useSelector((state) => ({
      data: state.Security.securityAuthRoleToUserList
        ?.securityauthroletouser_list,
      securityAuthRoleListAPI:
        state.Security.securityAuthRoleList?.securityauthrole_list,
      securityAuthRoleListLoading: state.Security.securityAuthRoleListLoading,
    }));
  const { staffData } = useSelector((state) => ({
    staffData: state.Staff.staffList?.staff_list,
  }));
  const [searchResults, setSearchResults] = useState([]);

  const columns = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
        filterable: false,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                <span className={"like-href"}> #{card.row.original.Id}</span>
              </div>
            </div>
          </>
        ),
      },

      {
        // job id  with beginning #Job_Id
        Header: "User",
        accessor: "User_Id",
        filterable: false,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 name">
                {
                  staffData?.find(
                    (item) => item.Id === card.row.original?.User_Id
                  )?.FullName
                }
              </div>
            </div>
          </>
        ),
      },
      {
        // job id  with beginning #Job_Id
        Header: "Role",
        accessor: "SecurityAuthRole_Id",
        filterable: false,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 name">
                {
                  securityAuthRoleListAPI?.find(
                    (item) => item.Id === card.row.original?.SecurityAuthRole_Id
                  )?.Name
                }
              </div>
            </div>
          </>
        ),
      },

      {
        Header: "Created Date",
        accessor: "CreatedDateTime",
        Cell: (row) => {
          //CreatedDateTime sort date so its day Month name Year and time

          return <div>{HandleDateTime(row.row.original?.CreatedDateTime)}</div>;

          // return row.CreatedDateTime
        },
        filterable: true,
      },
      //action edit delete
      {
        Header: "Delete",
        accessor: "action",
        Cell: (row) => {
          return (
            <div
              className="remove-item-btn"
              onClick={() => {
                setSelectForDelete([row.row.original?.Id]);
                setDeleteModal(true);
              }}
            >
              <div className={" d-flex align-items-center cursor-pointer"}>
                <i className="ri-delete-bin-fill align-center text-muted"></i>{" "}
                <span> Delete</span>
              </div>
            </div>
          );
        },
      },
    ],
    [searchResults]
  );
  const [search, setSearch] = useState("");
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "Id",
    "Notes",
    "Name",
    "Description",
  ]);
  useEffect(() => {
    let filteredCustomerList = data;

    const timer = setTimeout(() => {
      filteredCustomerList = filteredCustomerList?.filter((item) => {
        return allowedSearchFilters?.some((key) => {
          return (
            item[key] &&
            item[key]
              ?.toString()
              ?.toLowerCase()
              ?.includes(search?.toLowerCase())
          );
        });
      });

      setSearchResults(filteredCustomerList);
    }, 300);
    return () => clearTimeout(timer);
  }, [search, data]);
  const [selectForDelete, setSelectForDelete] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDelete = () => {
    dispatch(deleteSecurityAuthRoleToUser(selectForDelete));
  };
  const { securityAuthRoleToUserDeleteSuccessAPI } = useSelector((state) => ({
    securityAuthRoleToUserDeleteSuccessAPI:
      state.Security.securityAuthRoleToUserDeleteSuccess,
  }));
  useEffect(() => {
    if (isEmpty(securityAuthRoleToUserDeleteSuccessAPI)) return;
    if (securityAuthRoleToUserDeleteSuccessAPI.status === 200) {
      setDeleteModal(false);
      setSelectForDelete([]);
      dispatch(getSecurityAuthRoleToUserList());
      toast.success(securityAuthRoleToUserDeleteSuccessAPI.message);
    } else {
      toast.error(securityAuthRoleToUserDeleteSuccessAPI.message);
    }
    dispatch(deleteSecurityAuthRoleToUserSuccess([]));
  }, [securityAuthRoleToUserDeleteSuccessAPI]);
  const [modalCreateNew, setModalCreateNew] = useState(false);
  const toggleCreateNew = () => setModalCreateNew(!modalCreateNew);
  const initialCreate = {
    SecurityAuthRole_Id: "",
    User_Id: "",
  };
  const [createNewRoleToUser, setCreateNewRoleToUser] = useState(initialCreate);
  const handleAssignRoleToUser = () => {
    dispatch(createSecurityAuthRoleToUser([createNewRoleToUser]));
  };
  const {
    securityAuthRoleToUserCreateSuccessAPI,
    securityAuthRoleToUserCreateLoading,
  } = useSelector((state) => ({
    securityAuthRoleToUserCreateSuccessAPI:
      state.Security.securityAuthRoleToUserCreateSuccess,
    securityAuthRoleToUserCreateLoading:
      state.Security.securityAuthRoleToUserCreateLoading,
  }));

  useEffect(() => {
    if (isEmpty(securityAuthRoleToUserCreateSuccessAPI)) return;
    if (securityAuthRoleToUserCreateSuccessAPI.status === 200) {
      setModalCreateNew(false);
      setCreateNewRoleToUser(initialCreate);
      dispatch(getSecurityAuthRoleToUserList());
      toast.success(securityAuthRoleToUserCreateSuccessAPI.message);
    } else {
      toast.error(securityAuthRoleToUserCreateSuccessAPI.message);
    }
    dispatch(createSecurityAuthRoleToUserSuccess([]));
  }, [securityAuthRoleToUserCreateSuccessAPI]);
  return (
    <div>
      {modalCreateNew && (
        <AppModal
          open={modalCreateNew}
          onClose={toggleCreateNew}
          title="Assign Role To User"
          headerAccent="indigo"
          size="sm"
          loading={securityAuthRoleToUserCreateLoading}
          onSubmit={handleAssignRoleToUser}
          submitLabel="Assign"
          submitColor="primary"
        >
            <div>
              <div>
                <Label>Select User</Label>
                <Select
                  options={staffData?.map((item) => ({
                    value: item.Id,
                    label: item.FullName,
                  }))}
                  onChange={(e) => {
                    setCreateNewRoleToUser({
                      ...createNewRoleToUser,
                      User_Id: e.value,
                    });
                  }}
                  value={{
                    label: staffData?.find(
                      (item) => item.Id === createNewRoleToUser?.User_Id
                    )?.FullName,
                    value: createNewRoleToUser?.User_Id,
                  }}
                ></Select>
              </div>
              <div className={"pt-1"}>
                <Label>Select Role</Label>
                <Select
                  options={securityAuthRoleListAPI?.map((item) => ({
                    value: item.Id,
                    label: item.Name,
                  }))}
                  onChange={(e) => {
                    setCreateNewRoleToUser({
                      ...createNewRoleToUser,
                      SecurityAuthRole_Id: e.value,
                    });
                  }}
                  value={{
                    label: securityAuthRoleListAPI?.find(
                      (item) =>
                        item.Id === createNewRoleToUser?.SecurityAuthRole_Id
                    )?.Name,
                    value: createNewRoleToUser?.SecurityAuthRole_Id,
                  }}
                ></Select>
              </div>
            </div>
        </AppModal>
      )}
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onCloseClick={() => {
            setDeleteModal(false);
            setSelectForDelete([]);
          }}
          onDeleteClick={handleDelete}
        />
      )}
      <Row className="g-4 align-items-center">
        <Col sm={3}>
          <div className="search-box">
            <Input
              // create search with jobs List Data
              type="search"
              className="form-control search"
              placeholder="Search for..."
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              value={search}
            />
            <i className="ri-search-line search-icon"></i>
          </div>
        </Col>
        <div className="col-sm-auto ms-auto">
          <div className="hstack gap-2">
            <button className="btn btn-success" onClick={toggleCreateNew}>
              Assign Role To User
            </button>
          </div>
        </div>
      </Row>
      <div>
        {securityAuthRoleListLoading ? (
          <LoadingSpinner />
        ) : (
          <TableContainer
            columns={columns}
            data={searchResults || []}
            isGlobalFilter={false}
            isAddUserList={false}
            customPageSize={10}
            className="custom-header-css"
            divClass="table-responsive table-card mb-0"
            tableClass="align-middle  "
            theadClass="text-muted"
            // handleLeadClick={handleLeadClicks}
            isLeadsFilter={false}
          />
        )}
      </div>
    </div>
  );
};

export default SecurityRoleToUser;
